module.exports = __webpack_public_path__ + "static/media/77.60b43156.jpg";